import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/footer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/header.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Loader.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/LottieOverlay.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/PageTransition.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/SmoothScroll.js");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/next/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/@vercel/speed-insights/dist/next/index.mjs");
